// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { PureComponent } from "react";

import PropTypes from "prop-types";

import { SearchableListPanel, Flag } from "components/elements";
import { Checkbox } from "components/form/elements";

import styles from "./CountryRow.scss";

export class CountryRow extends PureComponent {
  static propTypes = {
    country: PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    isChecked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  handleChange = () => {
    const { country, isChecked, onChange } = this.props;
    onChange(country, !isChecked);
  };

  render() {
    const { country, isChecked } = this.props;

    return (
      <SearchableListPanel>
        <label className={styles.label}>
          <Flag countryCode={country.code.toLowerCase()} />
          <div className={styles.name}>{country.name}</div>
          <Checkbox
            checked={isChecked}
            onChange={this.handleChange}
            value={country.code}
          />
        </label>
      </SearchableListPanel>
    );
  }
}
